import type { ComponentProps } from "react"

export default function PropertyParking(
  props: ComponentProps<"svg"> & { fill?: string },
) {
  const { fill = "currentColor", ...svgProps } = props

  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M16 13.3335H14.6666V16.0002H16C16.3536 16.0002 16.6927 15.8597 16.9428 15.6096C17.1928 15.3596 17.3333 15.0205 17.3333 14.6668C17.3333 14.3132 17.1928 13.9741 16.9428 13.724C16.6927 13.474 16.3536 13.3335 16 13.3335Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.074 7.13115C11.8281 5.95909 13.8904 5.3335 16 5.3335C18.829 5.3335 21.5421 6.4573 23.5425 8.45769C25.5429 10.4581 26.6667 13.1712 26.6667 16.0002C26.6667 18.1098 26.0411 20.1721 24.8691 21.9262C23.697 23.6804 22.0311 25.0475 20.082 25.8549C18.1329 26.6622 15.9882 26.8734 13.9191 26.4619C11.85 26.0503 9.94933 25.0344 8.45757 23.5426C6.96581 22.0509 5.94991 20.1503 5.53834 18.0811C5.12676 16.012 5.338 13.8673 6.14533 11.9182C6.95266 9.96913 8.31984 8.30322 10.074 7.13115ZM14.6667 18.6668H16C17.0609 18.6668 18.0783 18.2454 18.8285 17.4953C19.5786 16.7451 20 15.7277 20 14.6668C20 13.606 19.5786 12.5885 18.8285 11.8384C18.0783 11.0883 17.0609 10.6668 16 10.6668H12V21.3335H14.6667V18.6668Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 0C12.8355 0 9.74207 0.938384 7.11088 2.69649C4.4797 4.45459 2.42894 6.95345 1.21793 9.87706C0.00693262 12.8007 -0.309921 16.0177 0.307443 19.1214C0.924806 22.2251 2.44866 25.0761 4.6863 27.3137C6.92394 29.5513 9.77487 31.0752 12.8786 31.6926C15.9823 32.3099 19.1993 31.9931 22.1229 30.7821C25.0466 29.5711 27.5454 27.5203 29.3035 24.8891C31.0616 22.2579 32 19.1645 32 16C31.9954 11.7579 30.3082 7.69095 27.3087 4.69136C24.3091 1.69177 20.2421 0.00458811 16 0ZM16 29.3333C13.3629 29.3333 10.7851 28.5513 8.5924 27.0863C6.39975 25.6212 4.69078 23.5388 3.68161 21.1024C2.67245 18.6661 2.4084 15.9852 2.92287 13.3988C3.43734 10.8124 4.70722 8.43661 6.57192 6.57191C8.43662 4.70721 10.8124 3.43733 13.3988 2.92286C15.9852 2.40839 18.6661 2.67244 21.1025 3.68161C23.5388 4.69077 25.6212 6.39974 27.0863 8.5924C28.5514 10.7851 29.3333 13.3629 29.3333 16C29.3295 19.535 27.9235 22.9242 25.4238 25.4238C22.9242 27.9234 19.535 29.3294 16 29.3333Z"
        fill={fill}
      />
    </svg>
  )
}
